require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./clients-salisbury-city-of-stories.json") })
        }
      }, "path---clients-salisbury-city-of-stories");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---clients-salisbury-city-of-stories!./.cache/json/clients-salisbury-city-of-stories.json
// module id = 1385
// module chunks = 231608221292675